import React, { useRef, useState } from 'react';

const Dropdown = ({ children, value, className }) => {
    const ref = useRef();
    const [isOpen, setIsOpen] = useState(false);

    const toggleDropdown = () => {
        setIsOpen(!isOpen);
    };


    const handleClickOutside = (event) => {
        if (ref.current && !ref.current.contains(event.target)) {
            setTimeout(() => setIsOpen(false), 50);
        }
    };

    useState(() => {
        document.addEventListener('click', handleClickOutside);
        return () => {            
            document.removeEventListener('click', handleClickOutside);
        };
    }, [])

    return (
        <div className={`relative w-full inline-block text-left ${className}`}>
            <div className={`w-full`} ref={ref}>
                <button
                    type="button"
                    // className={`inline-flex w-full justify-center gap-x-1.5 rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50`}
                    className={`w-full app-dropdown text-left`}
                    id="menu-button"
                    aria-expanded={isOpen}
                    aria-haspopup="true"
                    onClick={toggleDropdown}
                >
                    {value || '\u00A0'}
                </button>
            </div>
            {isOpen && (
                <div
                    className="max-h-60 w-full overflow-auto absolute left-0 z-10 mt-2 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none"
                    role="menu"
                    aria-orientation="vertical"
                    aria-labelledby="menu-button"
                    tabIndex="-1"
                >
                    <div className="py-1" role="none">
                        {children}
                    </div>
                </div>
            )}
        </div>
    );
};

export default Dropdown;